import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEuro: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconEuro"><Path d="M7.75 12H10.75M14.3021 9C13.7136 8.22784 12.8995 7.75 12 7.75C10.2051 7.75 8.75 9.65279 8.75 12C8.75 14.3472 10.2051 16.25 12 16.25C12.8995 16.25 13.7136 15.7722 14.3021 15M21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconEuro;
